import { useState, useEffect } from "react";
import MainContainer from "../../components/partials/maincontainer";
import About from "./components/about";
import DataCollection from "./components/data-collection";
import DataFlow from "./components/data-flow";
import ExternalDataSharing from "./components/external-data-sharing";
import FitForPurpose from "./components/fit-for-purpose";
import { apiCall } from "../../data/useFetcher";
import { useRequestStore } from "../../data/stores/loggerStore";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";

const RequestDetails = () => {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "about";
  const { dataSystemAll, getDynamicLogger }: any = useRequestStore();
  const [datum, setDatum] = useState(null);
  const navigate = useNavigate();
  // fetch ERP modules on mount
  useEffect(() => {
    dataSystemAll?.docs?.map((it: any) => it?._id === id && setDatum(it));
  }, [id, dataSystemAll]);
  // console.log(datum, "datum");
  useEffect(() => {
    if (!datum) return;
    apiCall({
      type: "get",
      url: `/api/v1/data-system/manage-effectivenesspurposelevel?datasystem=${
        datum?.erpModule
      }${
        datum?.organization
          ? `&organization=${datum?.organization?._id || datum?.organization}`
          : ""
      }`,
      getter: (d: any) => getDynamicLogger(d, "effectivenessOrg"),
    });
  }, [datum]);

  if (!datum) return null;
  const handleBack = () => {
    navigate("/invitation");
  };
  const tabs = [
    { id: "about", label: "About", component: <About data={datum} /> },
    {
      id: "data-collection",
      label: "Data Collection",
      component: <DataCollection data={datum} />,
    },
    {
      id: "data-flow",
      label: "Data Flow",
      component: <DataFlow data={datum} />,
    },
    {
      id: "external-data",
      label: "External Data Sharing",
      component: <ExternalDataSharing data={datum} />,
    },
    {
      id: "fit-purpose",
      label: "Fit For Purpose",
      component: <FitForPurpose data={datum} />,
    },
  ];

  const handleTabClick = (tabId: string) => {
    setSearchParams({ tab: tabId });
  };

  return (
    <div>
      <MainContainer>
        <div className="min-h-screen p-4">
          <div className="max-w-4xl">
            {/* Header */}
            <div className="flex items-center gap-3 mb-6" onClick={handleBack}>
              <button className="p-2 hover:bg-gray-100 rounded-md transition-colors">
                <svg
                  className="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
              <h1 className="text-xl font-semibold text-gray-900">
                ERP Module
              </h1>
            </div>

            {/* Navigation Tabs */}
            <div className="mb-6">
              <div className="flex w-fit bg-[#F9FAFB] border-[#F2F4F7] border rounded-lg py-2 px-3">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => handleTabClick(tab.id)}
                    className={`px-4 py-2 text-sm font-medium transition-colors ${
                      activeTab === tab.id
                        ? "bg-[white] rounded-lg text-[#344054]"
                        : "border-transparent text-[#667085] hover:text-gray-700 hover:border-gray-300"
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Active Tab Content */}
            {tabs.find((tab) => tab.id === activeTab)?.component}
          </div>
        </div>
      </MainContainer>
    </div>
  );
};

export default RequestDetails;
